export const generateIndustryColorMap = (industryList) => {
    const colors = [
      "magenta", "volcano", "orange", "gold", "lime", "green", "cyan", "blue",
      "geekblue", "purple", "red", "gray"
    ];
  
    const uniqueIndustries = [...new Set(industryList.map(type => type || "N/A"))];
  
    const colorMap = uniqueIndustries.reduce((acc, industry, index) => {
      acc[industry] = colors[index] || `hsl(${(index * 137.508) % 360}, 65%, 60%)`;
      return acc;
    }, {});
  
    return colorMap;
  };
  